module.exports = {"341721100":"尧渡镇","341721101":"东流镇","341721102":"大渡口镇","341721103":"胜利镇","341721104":"张溪镇","341721105":"洋湖镇","341721106":"葛公镇","341721107":"香隅镇","341721108":"官港镇","341721109":"昭潭镇","341721110":"龙泉镇","341721111":"泥溪镇","341721200":"花园乡","341721201":"木塔乡","341721202":"青山乡","341721400":"东至经济开发区","341721401":"大渡口经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341721.json
// module id = 1055
// module chunks = 0